<template>
  <div class="AiFavorableComments-page">
    <div class="card-block" v-if="showItem">
      <div class="block-title">选择主题</div>
      <div class="theme-radio-group">
        <div
            v-for="t in themeList"
            :key="t.id"
            class="theme-radio-card"
            :class="{ selected: themeItem.id === t.id }"
            @click="onChangeRadio(t)"
        >
          {{ t.themeName }}
        </div>
      </div>
    </div>

    <div class="card-block" v-if="showItem">
      <div class="block-title">选择平台</div>
      <div class="share-section">
        <div class="platform-list">
          <div
              v-for="(p, idx) in sharePlatforms"
              :key="p.value"
              class="platform-item"
              @click="onClickRouter(p)"
          >
            <!-- 图标与文字 -->
            <div class="platform-main" v-if="p.show">
              <img :src="p.icon" class="platform-icon" alt=""/>
              <div class="platform-content">
                <div class="platform-title">{{ p.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 微信 H5 底部提示 -->
    <div class="wx-page-bk" v-if="showWxPageBK">
      <img class="wx-page-bk-banner" src="@/assets/AiFavorableComments/AiFavorableCommentsBK.jpg" alt="">
      <!--      <img class="wx-page-bk-close" @click="showWxPageBK = false" src="@/assets/payClose.png" alt="">-->
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      //数据
      themeList: [],

      //选择的主题信息
      themeItem: {},
      sharePlatforms: [
        {
          label: "美团",
          value: "meituan",
          icon: require("@/assets/AiFavorableComments/mt-logo.png"),
          // deeplink:'imeituan://www.meituan.com/gc/poi/detail?id=',
          title: '写美团点评文案',
          // tips:'AI帮写文案，一键好评',
          type: 'mt',
          show:true,
        },
        {
          label: "大众点评",
          value: "dzdp",
          icon: require("@/assets/AiFavorableComments/dzdp-log.png"),
          title: '写大众点评评价',
          // deeplink: 'dianping://shopinfo?shopid=',
          // tips:'AI帮写文案，一键好评',
          type: 'dzdp',
          show:true,
        },
        // {
        //   label: "小红书",
        //   value: "xhs",
        //   icon: require("@/assets/AiFavorableComments/xhs-logo.png"),
        //   deeplink: 'xhsdiscover://',
        //   title:'小红书发笔记',
        //   tips:'AI帮写文案，一键好评',
        //   type:'xhs',
        // },
      ],
      showWxPageBK: false,
      showItem: false,
    };
  },

  mounted() {


    let params = this.getUrlParams(window.location.hash)

    if (params) {
      this.shopId = params.shopId
      this.uuid = params.uuid
      //修改头部名称
      document.title = params.shopName
      this.handleThemesInfo()
    }
  },

  methods: {
    // 判断是否是微信浏览器
    checkWxH5() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.includes("micromessenger")) {
        this.showWxPageBK = true;
      }
    },
    handleThemesInfo() {
      let data = {
        shopId: this.shopId,
        qrCodeId: this.uuid,
      }
      this.$POST("/customer/evaluation/copy/themes", data)
          .then(res => {
            const list = Array.isArray(res.data) ? res.data : [];

            this.themeList = list.map(item => ({
              ...item,
              images: item.images ? item.images.split(",")[0] : ''
            }));

            //只有一个主题的时候默认选中
            this.themeItem = this.themeList.length === 1 ? this.themeList[0] : {};
            this.showItem = true
            this.checkWxH5();
          }).catch(err => {
            this.showWxPageBK = false

            this.showItem = false
            this.$messageBox.alert(`${err.msg}`, '提示', {
              confirmButtonText: '确定',
            });
      })
    },
    //提取参数
    getUrlParams(url) {
      const queryString = url.split('?')[1] || '';
      const searchParams = new URLSearchParams(queryString);

      const params = {};
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }

      return params;
    },
    onChangeRadio(item) {
      this.themeItem = item;
    },
    onClickRouter(item) {
      if (!this.themeItem.id) {
        return this.$message.warning('请选择主题');
      }
      const routerData = {
        deeplink: item.deeplink,
        id: this.themeItem.id,
        shopId: this.shopId,
        qrCodeId: this.uuid,
        type: item.type,
      };

      // 跳转到详情页，携带参数
      this.$router.push({
        name: 'AiFavorableCommentsDetails',
        state: routerData
      });
    },
    getGridPosition(idx) {
      // 计算每行三个一组
      const col = (idx % 2) + 1;
      return {
        'grid-column': col
      };
    },
  }
};
</script>

<style scoped>
.AiFavorableComments-page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.card-block {
  padding: 16px;
}

.block-title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
}

.theme-radio-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 一行两个 */
  gap: 12px;
  width: 100%;
}

.theme-radio-card {
  height: 42px;
  line-height: 42px;
  text-align: center;
  padding: 0 10px;
  border: 2px solid #ccc;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theme-radio-card.selected {
  border-color: #409eff;
  background-color: #e8f4ff;
  color: #409eff;
  font-weight: 600;
}

.theme-radio-card:hover {
  border-color: #409eff;
  background-color: #f0f8ff;
}

.block-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}

.share-section {
  width: 100%;
}

.platform-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.platform-item {
  position: relative;
  text-align: center;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 12px;
  cursor: pointer;
  background: #f0f0f0;
  transition: background 0.2s;

}

.platform-status {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ff4d4f;
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
}

.platform-icon {
  width: 40px;
  height: 40px;
  //margin-right: 12px;
}

.platform-content {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.platform-title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.platform-tips {
  font-size: 12px;
  color: #666;
}

.wx-page-bk {
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.wx-page-bk-banner {
  width: 100%;
  height: 100%;

}

.wx-page-bk-close {
  width: 38px;
  height: 38px;
  position: absolute;
  left: 50%;
  bottom: 50px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 1px solid black;
}
</style>


